import store from '../../../redux/store';

export const checkPermission = (module_id: number, incoming_permission: string) => {

    let permissions = store.getState().permission.permissions;

    return permissions.filter((permission) => permission.module_id === module_id && permission.module_key.includes(incoming_permission)).length > 0 ? true : false;

}

export const permissionType = {
    SITE_MODULE: 1,
    RANKING_MODULE: 2,
    ROLE_MANAGEMENT: 3,
    POST_MODULE: 4,
    MANAGER_MODULE: 5,
    INCENTIVE_MODULE: 6,
    USER_MODULE: 7,
    NOTIFICATION_MODULE: 8,
    BROKER_MODULE: 9,
    GROUP_MODULE: 10,
    VISIT_MODULE: 11,
    USER_REGISTRATION_REQUEST: 12,
    DASHBOARD_MODULE: 13,
}